import { Text } from "@mantine/core";
import type { RootRouter } from "@project/api";
import type { StripeError } from "@stripe/stripe-js";
import type { TRPCClientErrorLike } from "@trpc/client";
import type { FC } from "react";

interface ErrorMessageProps {
  error?: Error | StripeError | TRPCClientErrorLike<RootRouter> | null;
}

export const ErrorMessage: FC<ErrorMessageProps> = ({ error }) => {
  if (error) {
    return (
      <Text c="red" size="sm">
        {error.message}
      </Text>
    );
  }
  return null;
};
